import type { ApiResponse } from '@/types/api';

import { api } from './api';

export interface BackupData {
  version: string;
  exportedAt: string;
  userId: number;
  userEmail: string;
  orders?: any[];
  clients?: any[];
  products?: any[];
}

export interface ImportResult {
  success: boolean;
  autoBackup: string;
  imported: {
    orders: number;
    clients: number;
    products: number;
  };
}

export const backupService = {
  export: async (options: { orders?: boolean; clients?: boolean; products?: boolean }): Promise<Blob> => {
    const params = new URLSearchParams();
    if (options.orders) params.append('orders', 'true');
    if (options.clients) params.append('clients', 'true');
    if (options.products) params.append('products', 'true');

    const response = await api.get(`/backup/export?${params.toString()}`, {
      responseType: 'blob',
    });

    return response.data;
  },

  import: async (password: string, data: BackupData): Promise<ImportResult> => {
    const response = await api.post<ApiResponse<ImportResult>>('/backup/import', {
      password,
      data,
    });
    return response.data.data;
  },
};

